import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "f-20 sz-primary-red--text"
}
const _hoisted_2 = ["innerHTML"]

import SliderComponent from '@/components/widgets/SliderSheet/SliderComponent.vue';
import { QUOTES_SLIDER } from '@/constants/slider';
import type { QuotesSlider } from '@/types';
import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SlidersContainer',
  setup(__props) {

const quotesSlider = ref<QuotesSlider[]>(QUOTES_SLIDER);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _directive_orphans = _resolveDirective("orphans")!

  return (_openBlock(), _createBlock(_component_v_col, { cols: "12" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "sz-red-background pt-5"
          }, {
            default: _withCtx(() => [
              _createVNode(SliderComponent, {
                items: quotesSlider.value,
                class: "mb-9 mx-2",
                title: _ctx.$t('home.quotesSlider.title'),
                "content-center": ""
              }, {
                default: _withCtx(({ item, toggle }) => [
                  _createVNode(_component_v_sheet, {
                    width: "350",
                    elevation: "4",
                    rounded: "",
                    color: "white",
                    class: "pa-5 pb-3 sz-primary-grey--text font-weight-medium mx-3 d-md-block",
                    onClick: toggle
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: 24,
                        class: "mb-3"
                      }, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                          _createTextVNode(" $quote ")
                        ])),
                        _: 1
                      }),
                      (item?.title)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(item.title), 1))
                        : _createCommentVNode("", true),
                      (item?.quote)
                        ? _withDirectives((_openBlock(), _createElementBlock("p", {
                            key: 1,
                            class: "f-16",
                            innerHTML: item.quote
                          }, null, 8, _hoisted_2)), [
                            [_directive_orphans]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              }, 8, ["items", "title"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})